import React from 'react';
import './LoadingOverlay.css';

interface LoadingOverlayProps {
  show: boolean;
  message?: string;
}

export default function LoadingOverlay({ show, message }: LoadingOverlayProps) {
  if (!show) return null;
  return (
    <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="loading-overlay-content">
        <div className="loading-overlay-spinner" aria-hidden="true" />
        {message && <p className="loading-overlay-message">{message}</p>}
      </div>
    </div>
  );
}
